<template>
  <div class="bg-black h-full w-full absolute bg-opacity-25 flex justify-center items-center">
    <div class="bg-white w-2/4 rounded-lg flex flex-col">
      <slot></slot>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BaseModalCard',
  };
</script>
